import React from 'react';
import FolderEdit from '@Builder/myFolder/edit/FolderEdit';
import FolderMake from '@Builder/myFolder/make/FolderMake';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { container } from '@Container';
import { TYPES } from '@Types';
import { MyFolderAction } from '@Redux/actions';
import FolderAddArmy from '@Builder/myFolder/addArmy/FolderAddArmy';
import MyFolderDelete from '@Builder/myFolder/delete/MyFolderDelete';
import FolderToEvent from '@Builder/myFolder/event/FolderToEvent';
import ShareFolder from '@Builder/myFolder/share/ShareFolder';
import { folderPresenter } from '@Selectors/builder/myFolder/common/folderPresenter';
import { Link, useParams } from 'react-router-dom';
import folderSlice from '@Redux/reducers/builder/folder.slice';
import { FolderActionState } from '@Stores/builder/FolderState';

const MyFolderPageShow: React.FC<MyFolderPageShowProps> = ({
                                                                 folder,
                                                                 requestAddArmy,
                                                                 requestDelete,
                                                                 requestEdit,
                                                                 requestToEvent,
                                                                 requestShareFolder,
                                                                 loadFolder,
                                                                 toMake,
                                                                 toDelete,
                                                                 toEdit,
                                                                 toEvent,
                                                                 toShare,
                                                                 toAddArmyList,
                                                               }) => {

  const params = useParams();
  const folderId = params.folder_id;

  if (!folderId) {
    return <div>
      Folder not found!
    </div>
  }

  React.useEffect(() => {
    loadFolder(folderId);
  }, []);

  let content = <FolderMake/>;
  if (requestAddArmy) content = <FolderAddArmy/>;
  if (requestDelete) content = <MyFolderDelete/>;
  if (requestEdit) content = <FolderEdit/>;
  if (requestToEvent) content = <FolderToEvent/>;
  if (requestShareFolder) content = <ShareFolder/>;

  return <div>
    <div className="army_list row">
      <div className="col-12 col-md-2 mt-1 text-center">
        <a href="#" onClick={() => toMake()}><i className="fas fa-clipboard-list fa-2x"/></a>
      </div>

      <div className="col-12 col-md-8 mt-1 d-flex flex-row">
      </div>

      <div className="col-12 col-md-2 mt-1 mb-1 text-center">
        <a href="#" onClick={() => toDelete()}><i className="fas fa-trash fa-2x"/></a>
        <a href="#" onClick={() => toEdit()}><i className="fas fa-edit fa-2x"/></a>
        <a href="#" onClick={() => toShare()}><i className="fas fa-share-alt fa-2x"/></a>
        <a href="#" onClick={() => toEvent()}><i className="fas fa-users fa-2x"/></a>
        <a href="#" onClick={() => toAddArmyList()}><i className="fas fa-plus fa-2x"/></a>
      </div>
    </div>

    <Breadcrumb>
      <BreadcrumbItem>
        <Link to={`/${document.documentElement.lang}/builder/army_lists`}>
          <i className="fa-solid fa-house"></i>
        </Link>
      </BreadcrumbItem>
      {folder.parentId !== null && <BreadcrumbItem>
        <Link to={`/${document.documentElement.lang}/builder/folders/${folder.parentId}`}>Folder: {folder.parentName}</Link>
      </BreadcrumbItem>}
      <BreadcrumbItem active>{folder.name}</BreadcrumbItem>
    </Breadcrumb>

    {content}
  </div>;
}


const mapStateToProps = (state: AppState, props: any) => ({
  folder: folderPresenter(state, props),
  requestAddArmy:  FolderActionState.AddArmyList === state.folder.action,
  requestDelete: FolderActionState.Delete === state.folder.action,
  requestEdit: FolderActionState.Edit === state.folder.action,
  requestToEvent: FolderActionState.ToEvent === state.folder.action,
  requestShareFolder: FolderActionState.Share === state.folder.action,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const folderAction = container.get<MyFolderAction>(TYPES.Actions.MyFolderAction);

  return {
    loadFolder: (id: string) => dispatch(folderAction.fetchData({entityId: id})),
    toMake: () => dispatch(folderSlice.actions.cancel()),
    toDelete: () => dispatch(folderSlice.actions.setRequest(FolderActionState.Delete)),
    toEdit: () => dispatch(folderSlice.actions.setRequest(FolderActionState.Edit)),
    toEvent: () => dispatch(folderSlice.actions.setRequest(FolderActionState.ToEvent)),
    toShare: () => dispatch(folderSlice.actions.setRequest(FolderActionState.AddArmyList)),
    toAddArmyList: () => dispatch(folderSlice.actions.setRequest(FolderActionState.AddArmyList)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyFolderPageShow);

type MyFolderPageShowProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
